import { Button } from 'antd';
import React from 'react';

import '../assets/css/user_booking_nav_buttons.css';

function UserBookingNavButtons({
  showNext = true,
  showPrev = true,
  onNext = () => {},
  onPrev = () => {},
  nextProps = {},
  prevProps = {},
  nextText = 'Continue',
  prevText = 'Back',
  prevColourClass = 'bg-grey',
  nextColourClass = 'sb-blue-bg',
  helpText = '',
  pageKey,
}) {
  const buttonStyle =
    ' user_booking_buttons__button border-0 gSemiBold brFull fs-20 white txt-center h-full pd-7 pd-left-24 pd-right-24 antd-link-button-override';

  if (!showNext && !showPrev) {
    return null;
  }
  return (
    <div className={'user_booking_buttons__container mg-top-10 mg-bottom-30'}>
      <div id={`${pageKey}_buttons`} className={'user_booking_buttons'}>
        {showPrev && (
          <Button
            type='primary'
            onClick={onPrev}
            {...prevProps}
            className={
              prevColourClass + ' ' + buttonStyle + ' ' + prevProps?.className
            }
          >
            {prevText}
          </Button>
        )}
        {showNext && (
          <Button
            type='primary'
            onClick={onNext}
            {...nextProps}
            className={
              nextColourClass + ' ' + buttonStyle + ' ' + nextProps?.className
            }
          >
            {nextText}
          </Button>
        )}
      </div>
      <div className={'user_booking_buttons__help_text gMedium'}>
        {helpText}
      </div>
    </div>
  );
}

export default UserBookingNavButtons;
